import {set} from 'lodash-es'

export default {
  setSignInfo (state, payload) {
    const { data, path } = payload
    set(state, path, data)
  },
  setAuditInfo(state, payload) {
    state.auditInfo = payload
  },
  resetAudit (state) {
    state.auditInfo = {}
  },
  pickSignType (state, type) {
    state.signType = type
  },
  setCheckStatus (state, payload) {
    const { data, path } = payload
     set(state, path, data)
  },
  setRequired (state, payload) {
    const { data, path } = payload
     set(state, path, data)
  },
  setCompleteStatus (state, payload) {
    const { data, path } = payload
     set(state, path, data)
 },
  // 门店关联主体的信息
  setRelatedParty (state, payload) {
    const { data, path } = payload
    set(state, path, data)
    console.log('根据shopId获取主体的信息========================》', state)
  },
  updateSignRelationShopList (state, payload) {
    state.relation = payload
  },
  updateAuditStatus (state, auditStatus) {
    state.auditInfo.status = auditStatus
  },
}
